import ChevronDoubleDownIcon from "@heroicons/react/16/solid/ChevronDoubleDownIcon";
import ChevronDoubleUpIcon from "@heroicons/react/16/solid/ChevronDoubleUpIcon";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Divider from "@mui/material/Divider";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../../assets/colors";

export const P = styling("p")({
  margin: "0",
});

export const Wrapper = styling("div")((props) => ({
  height: "100%",
  maxWidth: "1440px",
  margin: "1.875rem auto 0",

  padding: "0 6.25rem",

  "@media (max-width: 1279px)": {
    padding: "0 1.5rem",
  },

  "@media (max-width: 640px)": {
    margin: "1.5rem auto 0",
    padding: "0 1rem",
  },
}));

export const JobDetailWrapper = styling("div")({
  display: "grid",
  gridTemplateColumns: "2fr 1fr",
  gap: "2rem",
  boxSizing: "border-box",
  marginTop: "32px",

  "@media (max-width: 1279px)": {
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  },
});

export const JobDetailContainer = styling("div")({
  display: "flex",
  flexDirection: "column",
  flexBasis: "100%",
  flexGrow: 0,
  boxSizing: "border-box",
  maxWidth: "100%",

  margin: "0",
});

export const JobHighlightContainer = styling("div")({
  position: "sticky",
  top: "64px",

  alignSelf: "flex-start",
  height: "fit-content",
  zIndex: 10,
});

export const BoxContainer = styling(Box)({
  display: "flex",
});

export const ButtonStyled = styling(ButtonBase)({
  color: Color.textHighEmphasis,
  backgroundColor: Color.white,
  border: `1px solid ${Color.black}`,
  borderRadius: "0.5rem",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: "0",
  gap: "10px",

  fontSize: "0.875rem",
  lineHeight: "20px",
  letterSpacing: "0.112px",
  textWrap: "nowrap",

  height: "48px",
  width: "fit-content",
  padding: "0px 1rem",

  "@media (max-width: 1279px)": {
    width: "fit-content",
  },

  "@media (max-width: 640px)": {
    fontSize: "1rem",
    lineHeight: "24px",

    width: "100%",
  },
});

export const ViewMoreButton = styling(ButtonBase)({
  color: Color.hiredlyPurple,
  borderRadius: "0.5rem",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.25rem",

  fontSize: "0.875rem",
  lineHeight: "24px",
  letterSpacing: "0.15px",

  textDecoration: "underline",
  textUnderlinePosition: "from-font",
});

export const LinkWrapper = styling(Link)({
  textDecoration: "none",
});

export const DividerStyled = styling(Divider)({});

export const ViewMoreIcon = styling(ChevronDoubleDownIcon)({
  width: "20px",
  height: "20px",
});

export const ViewLessIcon = styling(ChevronDoubleUpIcon)({
  width: "20px",
  height: "20px",
});
